import React from "react";

const Fitting = ()=> {
    return (
        <div className="container">
            <p>Примерка дома или в офисе</p>
        </div>
    )
}
export default Fitting;